<template>
<div class="chapter">
<div class="inner_page">
<p class="frontback">Contents</p>
<p class="toc"><a href="#/Text/Introduction">Introduction</a></p>
<p class="toc">Prologue: <a href="#/Text/Prologue">The Basics</a></p>
<p class="toc">PART I: <a href="#/Text/I">Misdirection</a></p>
<p class="toc2">1. <a href="#/Text/1">There is no consensus</a></p>
<p class="toc2">2. <span href="#/Text/2" title="Link target outside of Sample">It’s a conspiracy</span></p>
<p class="toc">PART II: <span href="#/Text/II" title="Link target outside of Sample">We Don’t Need to Worry</span></p>
<p class="toc2">3. <span href="#/Text/3" title="Link target outside of Sample">Who says climate change is such a bad thing?</span></p>
<p class="toc2">4. <span href="#/Text/4" title="Link target outside of Sample">We’re heading toward an Ice Age, so why worry about warming?</span></p>
<p class="toc2">5. <span href="#/Text/5" title="Link target outside of Sample">There’s no link between warming and extreme weather</span></p>
<p class="toc">PART III: <span href="#/Text/III" title="Link target outside of Sample">Climate Change Isn’t Happening</span></p>
<p class="toc2">6. <span href="#/Text/6" title="Link target outside of Sample">Feels pretty cold . . . where’s your global warming?</span></p>
<p class="toc2">7. <span href="#/Text/7" title="Link target outside of Sample">The planet isn’t getting warmer</span></p>
<p class="toc2">8. <span href="#/Text/8" title="Link target outside of Sample">Glaciers are growing, Antarctica is gaining ice</span></p>
<p class="toc2">9. <span href="#/Text/9" title="Link target outside of Sample">Climate is too complex to model or predict</span></p>
<p class="toc">PART IV: <span href="#/Text/IV" title="Link target outside of Sample">It’s Not Our Fault</span></p>
<p class="toc2">10. <span href="#/Text/10" title="Link target outside of Sample">There is no link between carbon dioxide and global temperature</span></p>
<p class="toc2">11. <span href="#/Text/11" title="Link target outside of Sample">It’s just a natural cycle</span></p>
<p class="toc2">12. <span href="#/Text/12" title="Link target outside of Sample">More carbon dioxide won’t make a difference</span></p>
<p class="toc2">13. <span href="#/Text/13" title="Link target outside of Sample">What about . . .</span></p>
<p class="toc">PART 5: <span href="#/Text/V" title="Link target outside of Sample">There’s Nothing We Can Do About It</span></p>
<p class="toc2">14. <span href="#/Text/14" title="Link target outside of Sample">Carbon taxes or cap-and-trade systems will destroy the economy, kill jobs, and hurt the poor</span></p>
<p class="toc2">15. <span href="#/Text/15" title="Link target outside of Sample">Renewable energy is too expensive or too variable</span></p>
<p class="toc">Epilogue: <span href="#/Text/Epilogue" title="Link target outside of Sample">Outlook</span></p>
<p class="toc"><span href="#/Text/Endnotes" title="Link target outside of Sample">Endnotes</span></p>
<p class="toc"><span href="#/Text/Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/Text/Index" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/Text/Authors" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?58eee794